import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";

const AgriFarmerInspectionReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/agrimis");
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [farmerNumber, setFarmerNumber] = useState("");
  const [farmerData, setFarmerData] = useState();
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [warehosuedata, setWarehosuedata] = useState([]);
  const [warehouseId, setWarehouseId] = useState();

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const [data, setData] = useState([]);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);
    setData([]);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
    setData([]);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getTemplateData } = useHttp();

  const fillTemplateData = (employeeId) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    // if (warehouseId > 0) {
    //   urlfilter = urlfilter + `&warehouseId=${warehouseId}`;
    // }

    // if (regionId > 0) {
    //   urlfilter = urlfilter + `&regionId=${regionId}`;
    // }
    // if (farmerNo != "") {
    //   urlfilter = urlfilter + `&farmerNo=${farmerNo}`;
    // }

    var url = `/api/agriFarmerInspectionReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getTemplateData(
      {
        url: url,
      },
      (data) => {
        console.log("reportdata", data);
        setData(data);
      }
    );
  };

  useEffect(() => {
    fillTemplateData(0, 0, "");
  }, [getTemplateData]);

  const concatenateDetails = (details, field) => {
    return details.map((detail) => detail[field] || "").join(" \n ");
  };

  const prepareDataForExcel = (tableData) => {
    return tableData.map((item) => {
      const details = item.farmInspectionDetail || [];
      return {
        farmInspectionDate: item.farmInspectionDate
          ? new Date(item.farmInspectionDate).toLocaleDateString("en-GB")
          : "NA",
        docNo: item.docNo,
        supervisorName: item.supervisorName,
        farmerName: item.farmerName,
        demoName: item.demoName,
        cropName: item.cropName,
        dateOfGabPlanting: item.dateOfGabPlanting
          ? new Date(item.dateOfGabPlanting).toLocaleDateString("en-GB")
          : "NA",
        activitiesCarriedOutByFarmer: item.activitiesCarriedOutByFarmer,
        otherRecommendationsComments: item.otherRecommendationsComments,
        farmersRemark: item.farmersRemark,
        complianceHeadName: concatenateDetails(details, "complianceHeadName"),
        complianceFieldName: concatenateDetails(details, "complianceFieldName"),
        controlType: concatenateDetails(details, "controlType"),
        observation: concatenateDetails(details, "observation"),
        justification: concatenateDetails(details, "justification"),
        createdDate: item.createdDate
          ? new Date(item.createdDate).toLocaleDateString("en-GB")
          : "NA",
      };
    });
  };

  const fieldsToExport = [
    "farmInspectionDate",
    "docNo",
    "supervisorName",
    // "farmerName",
    "demoName",
    "cropName",
    "dateOfGabPlanting",
    "activitiesCarriedOutByFarmer",
    "otherRecommendationsComments",
    "farmersRemark",
    "complianceHeadName",
    "complianceFieldName",
    "observation",
    "justification",
    "createdDate",
  ];

  const customHeaders = [
    "Inspection Date",
    "Doc No",
    "Executive name",
    // "Farmer Name",
    "Demo Name",
    "Crop Variety",
    "Date of Gab Planting",
    "Activities Carried Out By The Farmer During The Visit",
    "Other Recommendation & Comments",
    "Farmer's Remark",
    "Compliance Head Name",
    "Compliance Field Name",
    "observation",
    "justification",
    "Created Date",
  ];

  const preparedData = prepareDataForExcel(data);

  const handleExportExcel = () => {
    const filename = "AgriFarmerInspectionReport.xlsx";
    // console.log(fieldsToExport, customHeaders);

    convertToExcel(preparedData, fieldsToExport, filename, customHeaders);
  };

  //   const { sendRequest: getWarehouseData } = useHttp();

  //   const getWarehouseDetail = () => {
  //     getWarehouseData(
  //       {
  //         url: "/api/warehouses/",
  //       },
  //       (res) => {
  //         if (res) {
  //           setWarehosuedata(res);
  //         }
  //       }
  //     );
  //   };

  //   useEffect(() => {
  //     getWarehouseDetail();
  //   }, [getWarehouseData]);

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (region) => {
    var urlfilter = "";

    if (region > 0) {
      urlfilter = urlfilter + `&regionId=${region}`;
    }
    getEmp(
      {
        url: `/api/employeeListForProcReort/?useCase=Agri Promoter&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        // console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        //   setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  // const { sendRequest: getFarmerNumber } = useHttp();
  // useEffect(() => {
  //   getFarmerNumber(
  //     {
  //       url: `/api/farmerNumberList/?orgId=${localStorage.getItem(
  //         "orgId"
  //       )}&fieldExecutiveId=${employeeId}`,
  //     },
  //     (data) => {
  //       console.log("farmerNumberList", data);

  //       setFarmerData(data);
  //     }
  //   );
  // }, [employeeId]);

  // const handleSearch = (value) => {
  //   setFarmerNumber(value);
  // };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title">Agri Farmer Inspection Report</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Executive Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;

                      setEmployeeId(userid);
                      setData([]);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="row">
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillTemplateData(employeeId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>Sr.No</th>
                          <th>Inspection Date</th>
                          <th>Doc No</th>
                          <th>Executive Name</th>
                          {/* <th>Farmer Name</th> */}
                          <th>Demo Name</th>
                          <th>Crop Variety</th>
                          <th>Date of Gab Planting</th>
                          <th>
                            Activities Carried Out By The Farmer During The
                            Visit
                          </th>
                          <th>Other Recommendations & Comments</th>
                          <th>Farmer's Remark</th>

                          {/* Dynamic headers for Compliance Head Name */}
                          {currentItems &&
                            currentItems.length > 0 &&
                            (() => {
                              const groupedCompliance =
                                currentItems[0]?.farmInspectionDetail?.reduce(
                                  (acc, detail) => {
                                    const headName = detail.complianceHeadName;
                                    if (!acc[headName]) {
                                      acc[headName] = [];
                                    }
                                    acc[headName].push(detail);
                                    return acc;
                                  },
                                  {}
                                );

                              return Object.entries(groupedCompliance).map(
                                ([headName, fields], index) => (
                                  <th
                                    colSpan={fields.length * 2}
                                    className="pb-0 px-0"
                                    key={`head-${index}`}
                                  >
                                    {headName}
                                    <tr>
                                      {fields.map((field, subIndex) => (
                                        <th
                                          colSpan="2"
                                          className="pb-0 px-0"
                                          key={`field-${subIndex}`}
                                        >
                                          {field.complianceFieldName}
                                          <tr>
                                            <th className="pb-0">
                                              Observation
                                            </th>
                                            <th className="pb-0">
                                              Justification
                                            </th>
                                          </tr>
                                        </th>
                                      ))}
                                    </tr>
                                  </th>
                                )
                              );
                            })()}
                          <th>Created Date</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((item, index) => (
                            <tr key={`row-${index}`}>
                              {/* Static row values */}
                              <td>{index + 1}</td>
                              <td>{new Date(item.farmInspectionDate).toLocaleDateString()}</td>
                              <td>{item.docNo}</td>
                              <td>{item.supervisorName}</td>
                              {/* <td>{item.farmerName}</td> */}
                              <td>{item.demoName}</td>
                              <td>{item.cropName}</td>
                              <td>{new Date(item.dateOfGabPlanting).toLocaleDateString()}</td>
                              <td>{item.activitiesCarriedOutByFarmer}</td>
                              <td>{item.otherRecommendationsComments}</td>
                              <td>{item.farmersRemark}</td>

                              {/* Dynamic compliance field values */}
                              {(() => {
                                const groupedCompliance =
                                  item.farmInspectionDetail.reduce(
                                    (acc, detail) => {
                                      const headName =
                                        detail.complianceHeadName;
                                      if (!acc[headName]) {
                                        acc[headName] = [];
                                      }
                                      acc[headName].push(detail);
                                      return acc;
                                    },
                                    {}
                                  );

                                return Object.values(groupedCompliance).flatMap(
                                  (fields) =>
                                    fields.map((field, subIndex) => (
                                      <>
                                        <td
                                          style={{ width: "10%" }}
                                          key={`obs-${subIndex}`}
                                        >
                                          {field.observation || "N/A"}
                                        </td>
                                        <td
                                          style={{ width: "10%" }}
                                          key={`just-${subIndex}`}
                                        >
                                          {field.justification || "N/A"}
                                        </td>
                                      </>
                                    ))
                                );
                              })()}
                              <td>
                                {new Date(
                                  item.createdDate
                                ).toLocaleDateString()}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AgriFarmerInspectionReport;
